<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <div class="sl-card inline-block float-right">

        <!-- Return Action Buttons -->
        <div class="sl-card-buttons">
            <mdi-icon icon="mdiDelete" class="sl-card-button text-red-500" @click="deleteConfirmationOpen = true" />
        </div>

        <teleport to="body">
            <lsn-modal
                :is-open="deleteConfirmationOpen"
                @keydown.esc="deleteConfirmationOpen = false"
            >
                <div class="sl-prompt sl-prompt--danger">
                    <div class="sl-prompt__contents">
                        <div class="sl-prompt__title">
                            {{ $t('return.delete_confirmation') }}
                        </div>

                        <div class="sl-prompt__text">
                            {{ $t('common.action_irreversible') }}
                        </div>
                    </div>

                    <div class="sl-prompt__actions">
                        <button class="sl-prompt__button sl-prompt__button--white" @click.stop="deleteConfirmationOpen = false">
                            {{ $t('common.cancel') }}
                        </button>

                        <button
                            ref="removeBtn"
                            class="sl-prompt__button sl-prompt__button--red"
                            @click.stop="remove"
                        >
                            {{ $t('common.remove') }}
                        </button>
                    </div>
                </div>
            </lsn-modal>
        </teleport>

    </div>

</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

export default
{
    name: 'ReturnActionsCard',

    props:
    {
        oReturn:
        {
            type:     Object,
            required: true,
        },
    },

    emits: ['remove'],

    data()
    {
        return {
            deleteConfirmationOpen: false,
        };
    },

    methods:
    {
        remove()
        {
            this.$emit('remove', this.oReturn);
            this.deleteConfirmationOpen = false;
        },
    },
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="scss" scoped>



</style>
